import { FallAlertDataService } from "./data.fall-alert.service";

export const DATA_SERVICES = [
    FallAlertDataService
];